/**
 * @see https://stackoverflow.com/a/61395050/2252696
 * 合併兩個物件，並且對於物件中的物件進行深度合併。保留 target 完全原有的屬性，替換 source 上的新屬性，如果遇到 Array 則會替換相同索引的元素。
 */
export default function deepAssign(target: any, ...sources: any[]): any {
  if (typeof target !== 'object') {
    return target
  }
  for (const source of sources) {
    for (const k in source) {
      if (source.hasOwnProperty(k)) {
        const vs = source[k]
        const vt = target[k]
        if (vs !== null && typeof vs === 'object' && vt !== null && typeof vt === 'object') {
          target[k] = deepAssign(vt, vs)
        } else {
          target[k] = vs
        }
      }
    }
  }
  return target
}

/** 合併兩個物件，保留 target 完全原有的屬性，替換 source 上的新屬性，如果遇到 Array，則完全取代當中所有內容 */
export function deepReplace(target: any, source: any): any {
  if (typeof target !== 'object') {
    return target
  }
  if (source instanceof Array) {
    return deepClone(source)
  }
  for (const k in source) {
    if (source.hasOwnProperty(k)) {
      const vs = source[k]
      const vt = target[k]
      if (vs !== null && typeof vs === 'object' && vt !== null && typeof vt === 'object') {
        target[k] = deepReplace(vt, vs)
      } else {
        target[k] = vs
      }
    }
  }
  return target
}

/** 完全地複製物件及其深層的屬性 */
export function deepClone<T = any>(o: T): T { return JSON.parse(JSON.stringify(o)) }